export default __webpack_public_path__ + "static/img10-f3bf94fe6a2423dd26836f99e46e9999.png";